<template>
  <div class="ws-scrollable-wrap">
    <perfect-scrollbar
      ref="scrollContainer"
      v-scroll:throttle="{fn: $_onScroll, throttle: 32 }"
      class="content ps"
      :class="{disabled:disabled}"
      :options="{
        suppressScrollX:isDisabledX,
        suppressScrollY:isDisabledY,
        wheelPropagation:!isDisabledY,
      }"
    >
      <WsInfiniteScrollWrap001
        :scroll-position="value.scrollTop"
        :window-totle-height="value.windowTotalHeight"
        :model-name="modelName"
        :params="params"
        :parent-layers="parentLayers"
        :parent-models="parentModels"
        :model-parent="modelParent"
        :order-rules="orderRules"
        @loading="$emit('loading', $event)"
      >
        <template v-slot="{items,isLoading}">
          <slot
            :items="items"
            :isLoading="isLoading"
          />
        </template>
      </WsInfiniteScrollWrap001>
    </perfect-scrollbar>
  </div>
</template>
<script>
export default {
  name: "WsScrollableWrap001",
  props: {
    modelName: {
      type: String,
      default: "",
    },
    params: {
      type: Object,
      default() {
        return {};
      },
    },
    parentLayers: {
      type: Array,
      default() {
        return [];
      },
    },
    parentModels: {
      type: Object,
      default() {
        return {};
      },
    },
    modelParent: {
      type: String,
      default: "",
    },
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isDisabledY: {
      type: Boolean,
      default: false,
    },
    isDisabledX: {
      type: Boolean,
      default: false,
    },
    orderRules: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: () => ({
    position: {
      scrollTop: 0,
      scrollLeft: 0,
      scrollTotalHeight: 0,
      windowTotalHeight: 0,
    },
  }),
  watch: {
    position() {
      this.$emit("input", this.position);
    },
  },
  mounted() {
    this.position = this.value;
  },
  methods: {
    $_backToTop() {
      this.$_scrollTo({
        target: this.$refs.scrollContainer.$el,
        duration: 1000,
      });
    },
    $_scrollTo({ to = 0, target = null, duration = 300 }) {
      let start;
      if (!target) {
        start = document.body.scrollTop || document.documentElement.scrollTop;
      } else {
        start = target.scrollTop;
      }
      let change = to - start - 200;
      let currentTime = 0;
      let increment = 20;

      let animateScroll = function () {
        currentTime += increment;
        var val = Math.easeInOutQuad(currentTime, start, change, duration);
        if (!target) {
          document.body.scrollTop = val;
          document.documentElement.scrollTop = val;
        } else {
          target.scrollTop = val;
        }
        if (currentTime < duration) {
          setTimeout(animateScroll, increment);
        }
      };

      Math.easeInOutQuad = function (t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      };
      animateScroll();
    },
    $_onScroll(e, position) {
      this.position = position;
      this.position.scrollTotalHeight = e.target.scrollHeight;
      this.position.windowTotalHeight = e.target.offsetHeight;
      this.$emit("scroll-search");
    },
  },
};
</script>
<style lang="scss">
.ws-scrollable-wrap {
  .content {
    position: relative;
    overflow: hidden;
    height: calc(100vh - 76px);
    &.disabled {
      overflow: visible;
    }
  }
}
</style>